/** @format */

import { Space } from "antd";
import { ButtonDropdownExport } from "components/Button";
import InputSearch from "components/InputSearch";
import { TableWithPagination } from "components/Table/TableWithPagination";
import { useCallback, useEffect, useMemo, useState } from "react";
import { columnsDokumen } from "./Component/ColumnTable";
import { usePencairanBos } from "hooks/HookBos/usePencairanBos";
import { FilterVerification } from "./Component/FIlterVerification";
import { useDebounce } from "hooks/useDebounce";
import moment from "moment";
import { exportDataPengajuan } from "./Component/ExportDataPengajuan";
import notifAlert from "components/NotifAlert";
import { safe } from "utils/helper";

type contentType = {
  auth: any;
  provinsi: any[];
  kabkota: any[];
  store: any;
  dataState: any;
};
export const ContentVerification = ({
  auth,
  provinsi,
  kabkota,
  store,
  dataState,
}: contentType) => {
  const [search, setSearch] = useState<any>(null);
  const [tmpFilter, setTmpFilter] = useState<any>(null);
  const debouncedSearch = useDebounce(search, 400);
  const {
    loading,
    verifikasiSumberDanaBos,
    getDataVerification,
    updateVerfikasiPencairan,
    deleteDataPencairan,
  } = usePencairanBos(auth);

  useEffect(() => {
    if (auth?.isTahun) {
      getDataVerification(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [auth?.isTahun]);

  const handleDelete = useCallback(
    async (values: any) => {
      const res = await deleteDataPencairan(values, "verifikasi");
      if (res) {
        notifAlert({
          type: "success",
          description: "Penghapusan Data Madrasah Berhasil",
        });
      }
    },
    [deleteDataPencairan],
  );

  const columns = useMemo(() => {
    return columnsDokumen(provinsi, kabkota, handleDelete);
  }, [handleDelete, kabkota, provinsi]);

  const dataTable = useMemo(() => {
    let data = verifikasiSumberDanaBos;

    // search
    if (debouncedSearch) {
      const val = debouncedSearch.toLowerCase();

      data = data.filter((item: any) => {
        return (
          safe(item.provinsi).includes(val) ||
          safe(item.kabkota).includes(val) ||
          safe(item.nama_madrasah).includes(val) ||
          safe(item.nomor_rekening).includes(val) ||
          safe(item.nama_pemilik_rekening).includes(val) ||
          safe(item.nsm).includes(val)
        );
      });
    }

    if (tmpFilter?.tahap !== undefined) {
      data = data.filter(
        (item) => item.tahapan === tmpFilter?.tahap?.toString(),
      );
    }

    if (tmpFilter?.tanggal?.length === 2) {
      data = data.filter(
        (item) =>
          moment(tmpFilter.tanggal[0])
            .startOf("day")
            .isBefore(moment(item.tanggal_verifikasi)) &&
          moment(tmpFilter.tanggal[1])
            .endOf("day")
            .isAfter(moment(item.tanggal_verifikasi)),
      );
    }

    if (
      tmpFilter?.jenjang !== undefined &&
      tmpFilter?.jenjang !== null &&
      tmpFilter?.jenjang !== ""
    ) {
      const beforeJenjangFilter = data;
      data = data.filter(
        (item) => safe(item.jenjang) === safe(tmpFilter.jenjang),
      );
      if (
        process.env.NODE_ENV !== "production" &&
        beforeJenjangFilter.length &&
        !data.length
      ) {
        console.warn(
          "Filter jenjang tidak menghasilkan data — kemungkinan mismatch antara kode referensi jenjang dan item.jenjang dari API",
          tmpFilter.jenjang,
        );
      }
    }

    return data;
  }, [
    verifikasiSumberDanaBos,
    debouncedSearch,
    tmpFilter?.tahap,
    tmpFilter?.tanggal,
    tmpFilter?.jenjang,
  ]);

  const onChangeValueFilter = useCallback((_changed: any, allValues: any) => {
    setTmpFilter(allValues);
  }, []);

  const handleExportFile = (type: any) => {
    if (!dataTable.length) return;
    exportDataPengajuan(
      "VERIFIKASI",
      dataTable,
      type,
      auth?.isTahun,
      store,
      dataState,
    );
  };

  const onActionPengajuan = useCallback(
    async (values: any) => {
      const payload = {
        tahun: parseInt(auth?.isTahun),
        tahap: parseInt(values?.tahap),
        batch: parseInt(values?.batch),
        start_tanggal_verifikasi: moment(values?.tanggal[0]).format(
          "YYYY-MM-DDT00:00:00",
        ),
        end_tanggal_verifikasi: moment(values?.tanggal[1]).format(
          "YYYY-MM-DDT23:59:59",
        ),
        ...(values?.jenjang !== undefined &&
        values?.jenjang !== null &&
        values?.jenjang !== ""
          ? { jenjang: values.jenjang }
          : {}),
      };

      if (dataTable.length) {
        const res = await updateVerfikasiPencairan(payload);
        if (res) {
          notifAlert({
            type: "success",
            description: "Data Madrasah berhasil diajukan ke Bank",
          });
        }
      } else {
        notifAlert({
          type: "error",
          description: "Tidak ada data madrasah yang terpilih!!",
        });
      }
    },
    [auth?.isTahun, dataTable.length, updateVerfikasiPencairan],
  );

  return (
    <>
      <FilterVerification
        handleChangeValues={onChangeValueFilter}
        handleActionPengajuan={onActionPengajuan}
      />
      <div className="mb-4 flex justify-end">
        <div className="mr-4">
          <Space wrap>
            <ButtonDropdownExport handleExportFile={handleExportFile} />
          </Space>
        </div>
        <InputSearch
          className="w-3/4"
          onChange={(e: any) => setSearch(e.currentTarget.value)}
        />
      </div>
      <TableWithPagination
        loading={loading}
        columns={columns}
        dataTable={dataTable}
        rowKeyField="nsm"
      />
    </>
  );
};
